import { scrollTop } from "../../components/Helper";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "../../../node_modules/react-router-dom/dist/index";
import Dropzone from "../../components/Dropzone";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { CREATE_ADVERTISE_WITH_US, fetchData } from "../../components/Service";
import { PhoneNumberUtil } from "google-libphonenumber";
import { PhoneInput, defaultCountries, parseCountry } from "react-international-phone";
import "react-international-phone/style.css";
import { Context } from "../../components/Context";

const phoneUtil = PhoneNumberUtil.getInstance();

const Advertise = () => {
	const navigate = useNavigate();
	const [context] = useContext(Context);
	const [file, setFile] = useState("");
	const [defaultPhoneCountry] = useState("us");
	const [fullPhone, setFullPhone] = useState("");

	const countriesList = context?.countryList?.map((item) => item?.code?.toLowerCase()) || [];

	const countries = defaultCountries.filter((country) => {
		const { iso2 } = parseCountry(country);
		return countriesList.includes(iso2);
	});

	const {
		register,
		handleSubmit,
		formState: { errors },
		setError,
		clearErrors,
		setValue,
		trigger,
		reset,
	} = useForm({ mode: "onChange" });

	const isPhoneValid = (phone, country_code) => {
		try {
			// if (!phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))) {
			// 	setError("moblie", { message: "Phone is invalid." });
			// 	setValue("moblie", "");
			// } else {
			// 	clearErrors("moblie");
			// 	setValue("moblie", phone);
			// }

			const onlyPhone = phone.replace(`+${country_code}`, "").trim();
			if (onlyPhone) {
				setValue("moblie", phone, { shouldValidate: true });
				clearErrors("moblie");
			} else {
				setValue("moblie", "");
				// setError("moblie", { message: "Mobile number is required." });
			}
		} catch (error) {
			return false;
		}
	};

	const onFileDrop = (file, type) => {
		setFile(file);
		setValue("image", file.name);
		trigger("image");
	};

	const onSubmit = (data) => {
		const formData = new FormData();

		formData.append("first_name", data?.first_name);
		formData.append("last_name", data?.last_name);
		formData.append("business_name", data?.business_name);
		formData.append("email_id", data?.email_id);
		formData.append("website_link", data?.website_link);
		formData.append("mobile", data?.moblie);
		formData.append("message", data?.message);

		if (file && file.name) {
			formData.append("image", file, file?.name);
		}

		console.log("Form Data:", data);

		fetchData(CREATE_ADVERTISE_WITH_US, "POST", formData, true, true, (res) => {
			if (res.status) {
				toast.success("Ad information submitted  successfully.");
				navigate("/");
			} else {
				toast.error(res.message);
			}
		});
	};

	useEffect(() => {
		setValue("mobile", context?.user?.mobile ?? "");
		setValue("email_id", context?.user?.email ?? "");
		setValue("first_name", context?.user?.first_name ?? "");
		setValue("last_name", context?.user?.last_name ?? "");
		setFullPhone(context?.user?.mobile ?? "");
		scrollTop();
	}, []);

	return (
		<div className="col-lg-12">
			<div className="card card-forum">
				<div className="card-header usa-bg">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-3">
								<h4 class="text-white d-flex mb-0 py-2">Advertise With Us</h4>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body bg-white">
					<form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
						<div className="row">
							<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
								<label>
									First Name <span className="text-danger">*</span>
								
								</label>
								<input
									className={`form-control bg-transparent ${errors.first_name && "is-invalid"}`}
									placeholder="First Name"
									maxLength={50}
									{...register("first_name", {
										required: { value: true, message: "First name is required." },
										pattern: {
											value: /^[A-Za-z ]+$/,
											message: "Only alphabetic characters are allowed.",
										},
									})}
									readOnly={context?.user?.first_name?  true:false} 
								/>
								{errors.first_name && <div class="invalid-feedback">{errors.first_name.message}</div>}
							</div>
							<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
								<label>
									Last Name <span className="text-danger">*</span>
								</label>
								<input
									className={`form-control bg-transparent ${errors.last_name && "is-invalid"}`}
									placeholder="Last Name"
									maxLength={50}
									{...register("last_name", {
										required: { value: true, message: "Last name is required." },
										pattern: {
											value: /^[A-Za-z ]+$/,
											message: "Only alphabetic characters are allowed.",
										},
									})}
									readOnly={context?.user?.last_name?  true:false} 
								/>
								{errors.last_name && <div class="invalid-feedback">{errors.last_name.message}</div>}
							</div>
							<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
								<label>
									Email <span className="text-danger">*</span>
								</label>
								<input
									className={`form-control bg-transparent ${errors.email_id && "is-invalid"}`}
									placeholder="Email"
									type="email"
									maxLength={120}
									{...register("email_id", {
										required: { value: true, message: "Email is required." },
										pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: "Email is invalid." },
									})}
									readOnly={context?.user?.email_id?  true:false} 
								/>
								{errors.email_id && <div class="invalid-feedback">{errors.email_id.message}</div>}
							</div>
							<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
								<label>
									Mobile 
									{/* <span className="text-danger">*</span> */}
								</label>

								<PhoneInput
									key={defaultPhoneCountry}
									defaultCountry={defaultPhoneCountry}
									countries={countries}
									forceDialCode={true}
									value={fullPhone}
									hideDropdown={false}
									disableCountryGuess={true}
									onChange={(phone, country) => {
										isPhoneValid(phone, country.country.dialCode);
										setFullPhone(phone);
										setValue("country_code", `+${country.country.dialCode}` || "+1");
									}}
									className={`form-control bg-transparent p-0 ${errors.moblie ? "is-invalid" : ""}`}
								/>
								<input
									type="hidden"
									{...register("moblie", {
										// required: "Mobile number is required.",
									})}
								/>
								{errors.moblie && <div className="invalid-feedback">{errors.moblie.message}</div>}
							</div>

							<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
								<label>
									Business <span className="text-danger">*</span>
								</label>
								<input
									className={`form-control bg-transparent ${errors.business_name && "is-invalid"}`}
									placeholder="Business"
									{...register("business_name", {
										required: { value: true, message: "Business is required." },
									})}
								/>
								{errors.business_name && <div class="invalid-feedback">{errors.business_name.message}</div>}
							</div>

							<div className="col-sm-6 col-md-4 col-lg-3 mb-2">
								<label>Website Link</label>
								<input
									className={`form-control bg-transparent ${errors.website_link && "is-invalid"}`}
									placeholder="URL"
									{...register("website_link", {
										pattern: {
											value: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
											message: "Website link is invalid.",
										},
									})}
								/>
								{errors.website_link && <div class="invalid-feedback">{errors.website_link.message}</div>}
							</div>
							<div className="col-12 mb-2">
								<label>
									Message <span className="text-danger">*</span>
								</label>
								<textarea
									class={`form-control ${errors.message && "is-invalid"}`}
									rows="5"
									placeholder="Message"
									{...register("message", {
										required: { value: true, message: "Message is required." },
										minLength: { value: 3, message: "Message must be at least 3 characters." },
									})}
								></textarea>
								{errors.message && <div class="invalid-feedback d-block">{errors.message.message}</div>}
							</div>
							<div className="col-md-12">
								<div class="mb-2">
									<label class="form-label font12">Image</label>
									<span className="text-danger">*</span>
									<Dropzone
										className="dropzone"
										onFileDrop={onFileDrop}
										setError={setError}
										clearErrors={clearErrors}
										uploadFile="image"
										fieldName="file"
										fileSize={200}
										fileName={file}
									/>
									{file && <p>File Name: {file.name}</p>}
									{errors.image && <div class="invalid-feedback d-block">{errors.image.message}</div>}
									{errors.file && <div class="invalid-feedback d-block">{errors.file.message}</div>}
									<input
										type="hidden"
										{...register("image", {
											required: { value: true, message: "Image is required." },
										})}
									/>
								</div>
								<div>
									<span className="text-danger font12">Allowed JPG, PNG. Max file size </span>

									<span className="text-danger font-bold">200KB</span>
									<br />
									<span className="text-danger">
										If your upload image is larger than 200KB allowed, reduce the size of the image if you want to reduce the size of the image{" "}
										<Link to={"https://www.reduceimages.com/"} target="_blank">
											click this link.
										</Link>
										<br />
									</span>
								</div>
							</div>
						</div>
						<div className="text-end mt-3">
							<button class="btn btn-warning font13 d-inline-flex align-items-center" type="submit">
								Submit
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default Advertise;
